import { ColumnTypeEnum } from '@y42/json-schema';

export class ReplaceModel {
  constructor(
    public target = '',
    public manipulation: ReplaceManipulation = new ReplaceManipulation(),
    public outputType: string = ColumnTypeEnum.String,
    public manipulationType = 'Replace',
  ) {}
}
export class ReplaceManipulation {
  constructor(public targetColumn = '', public cases: ReplaceCase[] = [new ReplaceCase()]) {}
}

export class ReplaceCase {
  constructor(
    public token = '',
    public replaceWith = '',
    public fullMatch = false,
    public caseSensitive = false,
    public isNull = false,
  ) {}
}
